import React, { useState } from "react";

export const Search = ({ onSearch, className = "" }) => {
  const [query, setQuery] = useState("");

  const handleSearch = (e) => {
    const searchValue = e.target.value;
    setQuery(searchValue);
    onSearch(searchValue);
  };

  return (
    <input
      type="text"
      value={query}
      onChange={handleSearch}
      placeholder="Search..."
      className={`w-full px-4 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
    />
  );
};